export { A as Accordion } from './Accordion-ba12c90d.js';
export { default as AmenitiesList } from './AmenitiesList.js';
export { B as Button } from './Button-a16585e5.js';
export { C as Card } from './Card-003e3c50.js';
export { default as Carrousel } from './Carrousel.js';
export { default as Checkbox } from './Checkbox.js';
export { default as CheckboxGroup } from './CheckboxGroup.js';
export { default as Container } from './Container.js';
export { default as Description } from './Description.js';
export { default as DescriptionList } from './DescriptionList.js';
export { default as Divider } from './Divider.js';
export { default as FeedbackMessage } from './FeedbackMessage.js';
export { F as FlexiSearchBar, b as getAvailabilityFetcher, g as getCalendarPrices, w as withAvailabilityData, a as withPriceData } from './FlexiSearchBar-12e1db7a.js';
export { F as FullScreenPopup } from './FullScreenPopUp-701c26eb.js';
export { I as Icon } from './index-11bc5ac3.js';
export { default as Image } from './Image.js';
export { default as Input } from './Input.js';
export { default as Label } from './Label.js';
export { default as LazyImage } from './LazyImage.js';
export { default as LoadingSpinner } from './LoadingSpinner.js';
export { default as Location } from './Location.js';
export { default as MapView } from './MapView.js';
export { default as Modal } from './Modal.js';
export { default as NewTabLink } from './NewTabLink.js';
export { N as NumberPicker } from './index-66c14c2a.js';
export { default as OccupancySelectorContent } from './OccupancySelectorContent.js';
export { default as PhotoGallery } from './PhotoGallery.js';
export { P as PropertyCard } from './index-4e1cd670.js';
export { default as PropertiesList } from './PropertiesList.js';
export { default as PropertiesLayout } from './PropertiesLayout.js';
export { default as Radio } from './Radio.js';
export { R as ReactPortal } from './ReactPortal-f1f8cb85.js';
export { default as RoomDetailsModal } from './RoomDetailsModal.js';
export { default as Select } from './Select.js';
export { default as SearchInput } from './SearchInput.js';
export { default as SimpleMapView } from './SimpleMapView.js';
export { default as Switch } from './Switch.js';
export { default as Tabs } from './Tabs.js';
export { default as Textarea } from './Textarea.js';
export { default as Title } from './Title.js';
export { default as Toast } from './Toast.js';
export { P as PortalFilters } from './index-8f601c6e.js';
export { default as PaymentOptionGroups } from './PaymentOptionGroups.js';
export { default as PaymentAdviceRow } from './PaymentAdviceRow.js';
export { default as PanelTitle } from './PanelTitle.js';
export { default as Slider } from './Slider.js';
export { i as QueryParametersService } from './index-dcebcb46.js';
export { D as DayPickerRangeControllerWrapper, g as getRegionalLocale } from './DayPickerRangeControllerWrapper-189ca52a.js';
export { D as DateRangeSelectorInputs } from './DateRangeSelectorInputs-fe536172.js';
import { _ as _toConsumableArray, a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
export { S as SUPPORTED_REGION_LOCALES } from './general-2a8d8650.js';
import 'react';
import 'prop-types';
import './PropTypes-e1e509ba.js';
import 'moment';
import './utilsHelpers-e4b21f4b.js';
import './useComponentWidth-dbdc6efa.js';
import './useWindowSize-0dc36789.js';
import './react-select.esm-8a3af7ca.js';
import './_commonjsHelpers-17042db9.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';
import 'react-dom';
import './PopupV2-57d71c2c.js';
import './usePrevious-edd83563.js';
import './message-f222f616.js';
import './tslib.es6-2748fcb6.js';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './ModalHeader-77a50105.js';
import './handleOpenLink-49ba3691.js';
import 'react-slick';
import './Price.js';
import './index-f48c5efa.js';
import './provider-936ecd10.js';
import './LoadingBlock.js';
import './PropertyRating.js';
import './EmptySectionMessage.js';
import './Popup.js';
import './MapLayoutGoogle.js';
import './Paginator.js';
import './DropdownMenu.js';
import './useKeyPress-dea8da08.js';
import './PropertiesFilterByName.js';
import 'rc-slider';
import 'rc-slider/lib/Slider';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/zh-cn';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/th';
import 'moment/locale/sq';
import 'moment/locale/ar';
import 'moment/locale/be';
import 'moment/locale/bg';
import 'moment/locale/ca';
import 'moment/locale/hr';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/nl';
import 'moment/locale/eo';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/el';
import 'moment/locale/he';
import 'moment/locale/hi';
import 'moment/locale/hu';
import 'moment/locale/is';
import 'moment/locale/id';
import 'moment/locale/ga';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/lv';
import 'moment/locale/lt';
import 'moment/locale/mk';
import 'moment/locale/ms';
import 'moment/locale/mt';
import 'moment/locale/nb';
import 'moment/locale/pl';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/sr';
import 'moment/locale/sk';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/vi';
import 'moment/locale/en-gb';
import 'moment/locale/en-ca';
import 'react-dates/initialize';
import 'react-dates';
import './SearchBarItem.js';

var createOccupancyParameters = function createOccupancyParameters() {
  var occupancy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!(occupancy === null || occupancy === void 0 ? void 0 : occupancy.length)) {
    return '';
  }
  return occupancy.flatMap(function (occupancyData, roomIndex) {
    var _occupancyData$childr;
    var adults = occupancyData.adults;
    var params = [];
    if (adults) {
      params.push("adult_room".concat(roomIndex + 1, "=").concat(adults));
    }
    if (((_occupancyData$childr = occupancyData.children) === null || _occupancyData$childr === void 0 ? void 0 : _occupancyData$childr.length) > 0) {
      var childrenOccupancyCounts = occupancyData.children.reduce(function (counts, age) {
        counts[age] = (counts[age] || 0) + 1;
        return counts;
      }, {});
      params.push.apply(params, _toConsumableArray(Object.entries(childrenOccupancyCounts).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          age = _ref2[0],
          count = _ref2[1];
        return "child_room".concat(roomIndex + 1, "_age").concat(age, "=").concat(count);
      })));
    }
    return params;
  }).join('&');
};

export { createOccupancyParameters };
//# sourceMappingURL=index.js.map
